
const download = require('./download');



/* eslint-disable guard-for-in */
function getBrowser() {
  const rMsie = /(msie\s|trident\/7)([\w\\.]+)/;
  // const rTrident = /(trident)\/([\w.]+)/;
  const rEdge = /(chrome)\/([\w.]+)/;// IE

  const rFirefox = /(firefox)\/([\w.]+)/; // 火狐
  const rOpera = /(opera).+version\/([\w.]+)/; // 旧Opera
  // const rNewOpera = /(opr)\/(.+)/; // 新Opera 基于谷歌
  const rChrome = /(chrome)\/([\w.]+)/; // 谷歌
  const rUC = /(chrome)\/([\w.]+)/;// UC
  const rMaxthon = /(chrome)\/([\w.]+)/;// 遨游
  const r2345 = /(chrome)\/([\w.]+)/;// 2345
  const rQQ = /(chrome)\/([\w.]+)/;// QQ
  // const rMetasr = /(metasr)\/([\w.]+)/;// 搜狗
  const rSafari = /version\/([\w.]+).*(safari)/;
  const ua = navigator.userAgent.toLowerCase();
  let str = '';
  if (rMsie.exec(ua)) { //
    str = 'Microsoft IE浏览器';
  } else if (rEdge.exec(ua)) {
    str = 'Microsoft Edge浏览器';
  } else if (rUC.exec(ua)) {
    str = 'UC浏览器';
  } else if (rFirefox.exec(ua)) {
    str = '火狐浏览器';
  } else if (rOpera.exec(ua)) {
    str = 'Opera浏览器';
  } else if (rMaxthon.exec(ua)) {
    str = '遨游浏览器';
  } else if (r2345.exec(ua)) {
    str = '2345浏览器';
  } else if (rQQ.exec(ua)) {
    str = 'QQ浏览器';
  } else if (rSafari.exec(ua)) {
    str = 'Safari浏览器';
  } else if (rChrome.exec(ua)) {
    str = '谷歌浏览器';
  } else {
    str = '未知';
  }
  return str;
}

// 判断浏览器函数
function isMobile() {
  if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    return true; // 移动端
  } else {
    return false; // PC端
  }
}

//页面滚动静止/允许  0-静止 1-允许
function bodyScroll(event) {
  event.preventDefault();
}
function scrControl(t) {
  if (t == 0) { //禁止滚动
    document.body.addEventListener('touchmove', bodyScroll, { passive: false });
  } else if (t == 1) { //允许滚动
    document.body.removeEventListener('touchmove', bodyScroll, { passive: false });
  }
}

// GET 请求下直接合并参数
function assignParams(params = {}) {
  Object.assign(params, {
    packType: '1',
    version: '1.0.0',
    proxyid: sessionStorage.proxyId || sessionStorage.proxyid || '366',
    appkey: 'c76847d3a7bc4993b701551cc95cf0c0',
    appid: 19,
    deviceInfo: getBrowser(),
    userAgent: window.navigator.userAgent,
    ip: '192.168.0.1',
    fundTerminal: 1,
  });
  return params;
}
const linkToGoogle = () => {
  window.open(download.GoogleDownloadAddress)
}
const linkToApple = () => {
  window.open(download.AppleDownloadAddress)
}
const linkToAndroid = () => {
  window.open(download.AndroidDownloadAddress)
}
//截取url参数
function getQueryVariable(name) {
  var after = window.location.hash.split("?")[1];
  if (after) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    else {
      return null;
    }
  } else {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null)
      return unescape(r[2]);
    return null;
  }
}


const urlEncode = (param, key, encode) => {
  // 拼接参数
  if (param !== 0 && !param) {
    return '';
  }
  let paramStr = '';
  const t = typeof param;
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr += `&${key}=${encode == null || encode ? encodeURIComponent(param) : param}`;
  } else {
    // eslint-disable-next-line no-restricted-syntax
    for (const i in param) {
      const k = key == null ? i : key + (param instanceof Array ? `[${i}]` : `.${i}`);

      paramStr += urlEncode(param[i], k, encode);
    }
  }

  return paramStr;
};
/**
 * localStorage
 * @调用：xzLocal.set('token', 'access_token', 5000);
 * @调用：xzLocal.get('token');
 */
const xzLocal = {
  // 存储,可设置过期时间
  set(key, value, expires) {
    const params = { key, value, expires };
    let cpVal = null;
    if (expires) {
      // 记录何时将值存入缓存，毫秒级
      const data = Object.assign(params, { startTime: new Date().getTime() });
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      if (Object.prototype.toString.call(value) === '[object Object]') {
        cpVal = JSON.stringify(value);
      }
      if (Array.isArray(value)) {
        cpVal = JSON.stringify(value);
      }
      localStorage.setItem(key, cpVal);
    }
  },
  // 取出
  get(key) {
    const item = localStorage.getItem(key);
    if (!item) {
      return item;
    }
    let cpItem = null;
    // 先将拿到的试着进行json转为对象的形式
    try {
      cpItem = JSON.parse(item);
    } catch (error) {
      cpItem = item;
    }
    // 如果有startTime的值，说明设置了失效时间
    if (cpItem && cpItem.startTime) {
      const date = new Date().getTime();
      // 如果大于就是过期了，如果小于或等于就还没过期
      if (date - cpItem.startTime > cpItem.expires) {
        localStorage.removeItem(key);
        return false;
      }
    }
    return cpItem;
  },
  // 只出去value
  getVal(key) {
    const item = localStorage.getItem(key);
    if (!item) {
      return item;
    }
    let cpItem = null;
    // 先将拿到的试着进行json转为对象的形式
    try {
      cpItem = JSON.parse(item);
    } catch (error) {
      cpItem = item;
    }
    // 如果有startTime的值，说明设置了失效时间
    if (cpItem && cpItem.startTime) {
      const date = new Date().getTime();
      // 如果大于就是过期了，如果小于或等于就还没过期
      if (date - cpItem.startTime > cpItem.expires) {
        localStorage.removeItem(key);
        return false;
      }
    }
    return JSON.parse(cpItem.value);
  },
  // 删除
  remove(key) {
    localStorage.removeItem(key);
  },
  // 清除全部
  clear() {
    localStorage.clear();
  },
};

/**
 * sessionStorage
 */
const xzSession = {
  get(key) {
    const data = sessionStorage.getItem(key);
    if (!data) {
      return null;
    }
    return JSON.parse(data).value;
  },
  set(key, value) {
    const data = {
      value,
    };
    sessionStorage[key] = JSON.stringify(data);
  },
  // 删除
  remove(key) {
    sessionStorage.removeItem(key);
  },
  // 清除全部
  clear() {
    sessionStorage.clear();
  },
};
function isNotEmpty(obj) {
  try {
    if (obj == null || obj == undefined || obj == "null" || obj == "undefined") {
      return false;
    }
    //判断数字是否是NaN
    if (typeof obj === "number") {
      if (isNaN(obj)) {
        return false;
      } else {
        return true;
      }
    }
    //判断参数是否是布尔、函数、日期、正则，是则返回true
    if (typeof obj === "boolean" || typeof obj === "function" || obj instanceof Date || obj instanceof RegExp) {
      return true;
    }
    //判断参数是否是字符串，去空，如果长度为0则返回false
    if (typeof obj === "string") {
      if (obj.trim().length == 0) {
        return false;
      } else {
        return true;
      }
    }

    if (typeof obj === 'object') {
      //判断参数是否是数组，数组为空则返回false
      if (obj instanceof Array) {
        if (obj.length == 0) {
          return false;
        } else {
          return true;
        }
      }

      //判断参数是否是对象，判断是否是空对象，是则返回false
      if (obj instanceof Object) {
        //判断对象属性个数
        if (Object.getOwnPropertyNames(obj).length == 0) {
          return false;
        } else {
          return true;
        }
      }
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}
// 输入框验证是否有出现sql的关键字
function sqlValid(str) {
  const re = /select|update|delete|exec|count|'|"|=|;|>|<|%/i;
  if (re.test(str)) {
    return false;
  }
  return true;
}
function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "/";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = month + seperator1 + strDate + seperator1 + year;
  return currentdate;
}
function getSystem() {// 判断当前系统
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
  if (isAndroid) {
    return 'Android';
  } else {
    if (navigator.userAgent.match(/os\s+(\d+)/i) == null) {
      return '未知';
    } else {
      return 'IOS';
    }
  }
}


function callback(res) {
  console.log('callback:', res);
  if (res.ret === 0) {
    console.log(res.ret)
  }
}
// 定义回调函数
function loadErrorCallback() {
  var appid = '189979036';
  // 生成容灾票据或自行做其它处理
  var ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
  callback({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  });
}
export {
  assignParams,
  getBrowser,
  urlEncode,
  xzLocal,
  xzSession,
  sqlValid,
  isNotEmpty,
  getQueryVariable,
  isMobile,
  scrControl,
  linkToGoogle,
  linkToApple,
  getNowFormatDate,
  linkToAndroid,
  getSystem,
  loadErrorCallback
};

console.log("isNotEmpty")
if (!isNotEmpty(sessionStorage.proxyid) && isNotEmpty(getQueryVariable("proxyid"))) {
  sessionStorage.proxyid = getQueryVariable("proxyid");
} else if (isNotEmpty(sessionStorage.proxyid) && isNotEmpty(getQueryVariable("proxyid")) && sessionStorage.proxyid != getQueryVariable("proxyid")) {
  sessionStorage.proxyid = getQueryVariable("proxyid");
}
if (!isNotEmpty(sessionStorage.proxyId) && isNotEmpty(getQueryVariable("proxyId"))) {
  sessionStorage.proxyId = getQueryVariable("proxyId");
} else if (isNotEmpty(sessionStorage.proxyid) && isNotEmpty(getQueryVariable("proxyId")) && sessionStorage.proxyid != getQueryVariable("proxyId")) {
  sessionStorage.proxyid = getQueryVariable("proxyId");
}